export interface TransactionLogFilter {
  userId: string;
  transactionType: string;
  transactionDate: string;
  transactionResult: string;
  sort: string;
}

export const TransactionResultList: string[] = ['Pass', 'Failed'];
